import React from 'react';
import Calculator from '../components/Calculator/Calculator';

function Calculator2() {
  return (
    <>
      <div>
        <h1 className="calc-head">Let&apos;s do some Math</h1>
      </div>
      <div>
        <Calculator />
      </div>
    </>
  );
}

export default Calculator2;
